import React from 'react';

import { Company } from '_lib/api/apiTypes.shim';
import { DialogButton } from '_lib/components/DialogButton/DialogButton';
import { DialogContent } from '_lib/components/DialogContent/DialogContent';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';
import { DialogWrapper } from '_lib/featureComponents/DialogWrapper/DialogWrapper';
import { AsyncDialog, AsyncDialogProps, useAsyncDialog } from '_lib/hooks/useAsyncDialog';

interface SelectSisterCompanyDialogProps extends AsyncDialogProps<Company> {
  sisterCompanies: Company[];
}

const SelectSisterCompanyDialog = (props: SelectSisterCompanyDialogProps) => {
  const { onClose, titleText, sisterCompanies, ...dialogProps } = props;

  return (
    <DialogWrapper onClose={onClose} titleText={titleText || 'SELECT COMPANY IN SERVICE AREA'} {...dialogProps}>
      <DialogContent>
        {sisterCompanies?.map((sisterCompany) => (
          <FlexBox key={sisterCompany.id} sx={{ padding: 1 }}>
            <DialogButton
              onClick={() => onClose({ action: 'CONFIRM', value: sisterCompany })}
              text={sisterCompany.name}
            />
          </FlexBox>
        ))}
      </DialogContent>
    </DialogWrapper>
  );
};

interface SelectSisterCompanyDialog extends AsyncDialog<Company, SelectSisterCompanyDialogProps> {}
export const useSelectSisterCompanyDialog = (): SelectSisterCompanyDialog => useAsyncDialog(SelectSisterCompanyDialog);
